import React, { useMemo } from "react";
import { Typography, Stack, Box } from "@mui/material";
import SkillItemRow from "./SkillItemRow";
import { JOB_COLOR } from "../../../constants/colors";
import InnerFrame from "../../shared/InnerFrame";
import {
  compareByParentSkillLevelExperienceAndDisplayName,
  compareByExperienceAndDisplayName,
} from "../../utils/sortSkills";
/**
 * スキルカテゴリ表示コンポーネント
 * - 言語ごとに Paper（カード）でまとめる
 */
const SkillCategory = ({ category, owner, showEditButton }) => {
  // categoryがない時は表示しない
  if (!category?.skillGroups || category.skillGroups.length === 0) {
    return null;
  }

  const isTool = category.categoryKey === "tool";

  const sortedSkillGroups = useMemo(() => {
    const normalizedSkillGroups = Array.isArray(category?.skillGroups)
      ? category.skillGroups
      : [];

    const compareSkillGroups = isTool
      ? compareByExperienceAndDisplayName
      : compareByParentSkillLevelExperienceAndDisplayName;

    return [...normalizedSkillGroups].sort(compareSkillGroups);
  }, [category?.skillGroups]);

  return (
    <Box>
      {/* カテゴリ名（フロントエンド / バックエンド） */}
      <Typography fontWeight="bold" sx={{ color: JOB_COLOR }}>
        {category.categoryLabel}
      </Typography>

      {/* 言語ごとのカード一覧 */}
      <Stack spacing={2}>
        {sortedSkillGroups.map((skillGroup) => (
          <InnerFrame key={skillGroup.groupId}>
            {/* 言語1行分の表示（言語名 / 経験月数 / ランク / FW一覧） */}
            <SkillItemRow
              parentSkill={skillGroup.parentSkill}
              childSkills={skillGroup.childSkills}
              owner={owner}
              categoryKey={category.categoryKey}
              showEditButton={showEditButton}
            />
          </InnerFrame>
        ))}
      </Stack>
    </Box>
  );
};

export default SkillCategory;
